import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import Avatar from '../../../common/components/avatar';
import Rating from '../../../common/components/rating';

const { Stack, Heading, HorizontalStack, Paragraph } = designSystem;

const ReviewBanner = ({ reviewerName, reviewText, avatarUrl }) => (
  <div className="ws-difm-upsell-review-banner">
    <Stack gap="spacing-2-xs">
      <div className="ws-difm-upsell-review-banner__header">
        <HorizontalStack gap="spacing-2-xs" alignItems="center">
          <Avatar size={24} src={avatarUrl} />

          <Heading type="heading-6">{reviewerName}</Heading>
        </HorizontalStack>
        <Rating stars={5} size={16} />
      </div>
      <Paragraph size="medium" appearance="high-emphasis">
        {reviewText}
      </Paragraph>
    </Stack>
  </div>
);

ReviewBanner.propTypes = {
  reviewText: PropTypes.string.isRequired,
  reviewerName: PropTypes.string.isRequired,
  avatarUrl: PropTypes.string.isRequired,
};

export default ReviewBanner;
